@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';

.collapsible-list-section-content {
  width: 100%;
  background-color: @collapsable-list--content--background-color;
  overflow: auto;
  flex: 1;
  border-radius: inherit;
}
